'use client';

import { c as _c } from "react/compiler-runtime";
import { type Factiii, type PostFactiii } from '@shared/all/domains/factiiis';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import FactiiiSummaryCard from './FactiiiSummaryCard';
type Props = {
  factiii: Factiii;
  pfc: PostFactiii;
  // Passed through to the summary card (see its `post` prop).
  post?: {
    id: string;
    isAuthor: boolean;
  };
  anchorRect: DOMRect;
  visible: boolean;
  // Keep the card open while the pointer is over it (so its buttons are
  // clickable), and re-arm the close timer when the pointer leaves.
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onViewRawData: (scrapeId: number) => void;
};
const CARD_WIDTH = 280;
const CARD_MARGIN = 8;
export default function FactiiiAvatarHoverCard(t0) {
  const $ = _c(21);
  const {
    factiii,
    pfc,
    post,
    anchorRect,
    visible,
    onMouseEnter,
    onMouseLeave,
    onViewRawData
  } = t0;
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const raf = requestAnimationFrame(() => setMounted(true));
      return () => cancelAnimationFrame(raf);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (typeof window === "undefined") {
    return null;
  }
  const viewportH = window.innerHeight;
  const viewportW = window.innerWidth;
  const cardLeft = Math.min(Math.max(CARD_MARGIN, anchorRect.left + anchorRect.width / 2 - CARD_WIDTH / 2), viewportW - CARD_WIDTH - CARD_MARGIN);
  const spaceAbove = anchorRect.top;
  const placeBelow = spaceAbove < 220 && viewportH - anchorRect.bottom > spaceAbove;
  let t3;
  if ($[2] !== anchorRect.bottom || $[3] !== anchorRect.top || $[4] !== cardLeft || $[5] !== placeBelow) {
    t3 = placeBelow ? {
      top: anchorRect.bottom + CARD_MARGIN,
      left: cardLeft
    } : {
      bottom: viewportH - anchorRect.top + CARD_MARGIN,
      left: cardLeft
    };
    $[2] = anchorRect.bottom;
    $[3] = anchorRect.top;
    $[4] = cardLeft;
    $[5] = placeBelow;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const style = t3;
  const isShown = mounted && visible;
  const portalTarget = document.fullscreenElement ?? document.body;
  const t4 = isShown ? 1 : 0;
  const t5 = `translateY(${isShown ? 0 : placeBelow ? -4 : 4}px)`;
  let t6;
  if ($[7] !== style || $[8] !== t4 || $[9] !== t5) {
    t6 = {
      ...style,
      width: CARD_WIDTH,
      position: "fixed",
      zIndex: 400,
      opacity: t4,
      transform: t5,
      transition: "opacity 150ms ease-out, transform 150ms ease-out"
    };
    $[7] = style;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== factiii || $[12] !== onViewRawData || $[13] !== pfc || $[14] !== post) {
    t7 = <FactiiiSummaryCard factiii={factiii} pfc={pfc} post={post} onViewRawData={onViewRawData} />;
    $[11] = factiii;
    $[12] = onViewRawData;
    $[13] = pfc;
    $[14] = post;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onMouseEnter || $[17] !== onMouseLeave || $[18] !== t6 || $[19] !== t7) {
    t8 = createPortal(<div style={t6} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={_temp} className="rounded-lg border border-ds-border-standard bg-background-secondary p-3 shadow-xl" role="tooltip">{t7}</div>, portalTarget);
    $[16] = onMouseEnter;
    $[17] = onMouseLeave;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(e) {
  return e.stopPropagation();
}